// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalDialog_overlay__BcKjI {
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 39, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 1000;
}

.ModalDialog_dialog__1Wobe {
  width: min(100%, 460px);
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.22);
  border: 1px solid #d8e1e8;
  padding: 18px;
}

.ModalDialog_title__-SHJt {
  margin: 0 0 8px;
  color: #1f2f3d;
  font-size: 1.1rem;
}

.ModalDialog_body__p0N2M {
  color: #4b5d6c;
  line-height: 1.5;
}

.ModalDialog_actions__rIjrL {
  margin-top: 18px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.ModalDialog_secondaryButton__jKK7J,
.ModalDialog_primaryButton__Ywnty {
  border: none;
  border-radius: 10px;
  padding: 9px 14px;
  cursor: pointer;
  font-size: 0.92rem;
}

.ModalDialog_secondaryButton__jKK7J {
  background: #edf2f7;
  color: #1f2f3d;
}

.ModalDialog_primaryButton__Ywnty {
  background: #3498db;
  color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/components/ModalDialog.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(17, 24, 39, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  z-index: 1000;\n}\n\n.dialog {\n  width: min(100%, 460px);\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.22);\n  border: 1px solid #d8e1e8;\n  padding: 18px;\n}\n\n.title {\n  margin: 0 0 8px;\n  color: #1f2f3d;\n  font-size: 1.1rem;\n}\n\n.body {\n  color: #4b5d6c;\n  line-height: 1.5;\n}\n\n.actions {\n  margin-top: 18px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.secondaryButton,\n.primaryButton {\n  border: none;\n  border-radius: 10px;\n  padding: 9px 14px;\n  cursor: pointer;\n  font-size: 0.92rem;\n}\n\n.secondaryButton {\n  background: #edf2f7;\n  color: #1f2f3d;\n}\n\n.primaryButton {\n  background: #3498db;\n  color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `ModalDialog_overlay__BcKjI`,
	"dialog": `ModalDialog_dialog__1Wobe`,
	"title": `ModalDialog_title__-SHJt`,
	"body": `ModalDialog_body__p0N2M`,
	"actions": `ModalDialog_actions__rIjrL`,
	"secondaryButton": `ModalDialog_secondaryButton__jKK7J`,
	"primaryButton": `ModalDialog_primaryButton__Ywnty`
};
export default ___CSS_LOADER_EXPORT___;
